import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setComp, savePage } from './redux'
import { withRouter } from 'react-router-dom'

import Main from './main'
import LoginComp from "./themes/netalo/login"
import RegisterComp from "./themes/netalo/register"
import ErrorBoundary from './errorComponent'

const rxio = global.rootRequire('classes/socket').default
const { rxaget, changeTheme, changeThemeColor, changeTheme_ThemeColor, isElectron } = global.rootRequire('classes/ulti')
const { rxgetLocal } = global.rootRequire('classes/request')
const themeData = global.rootRequire('classes/themeData.json')
const themeColorData = global.rootRequire('classes/themeColorData.json')
const theme_themeColorData = global.rootRequire('classes/theme_themeColorData.json')

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      flagAuth: false,
      flagRegister: this.props.register
    }
    this.keyClickFunction = this.keyClickFunction.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keyClickFunction, false);
    const color = global.rxu.json(rxgetLocal('netaThemeColor'), '')
    const themeBackGround = global.rxu.json(rxgetLocal('netaThemeBackGround'), '')
    const token = rxaget(this.props, 'netaauth.user.token', '')
    const userid = rxaget(this.props, 'netaauth.user.id', '')
    console.log('color', color, { themeColorData })
    if (themeBackGround === 'darkTheme') {
      changeTheme(themeData.nightTheme)
      changeTheme_ThemeColor(theme_themeColorData.nightTheme)
    } else {
      changeTheme(themeData.defaultTheme)
      if (color === 'blueColor') {
        changeTheme_ThemeColor(theme_themeColorData.blueColor)
      } else {
        changeTheme_ThemeColor(theme_themeColorData.orangeColor)
      }
    }

    if (color === 'blueColor') {
      changeThemeColor(themeColorData.blueColor)
    } else if (color === 'bobacuColor') {
      changeThemeColor(themeColorData.bobacuColor)
    } else {
      changeThemeColor(themeColorData.orangeColor)
    }


    if (token && userid) {
      if (!rxio.connected && !rxio.init_connected) {
        rxio.login(token, userid, (data) => {
        })
      }
    }

    if (window && window.ipcRenderer) {
      window.ipcRenderer.on('helper_page', () => {
        try {
          this.props.setComp('config')
          this.props.savePage('chtg')
        } catch (e) { }
      })
    }

    if (rxaget(this.props, 'netaauth.user.id', '')) {
      this.setState({ flagAuth: true })
    } else {
      this.setState({ flagAuth: false })
    }

    // Check if the current path is '/register' and redirect to register page
    if (this.props.location.pathname === '/register') {
      this.setState({ flagRegister: true })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false);
  }

  componentDidUpdate(prevProps, prevState) {
    const tokenCurren = rxaget(this.props, 'netaauth.user.token', '')
    const tokenPrev = rxaget(prevProps, 'netaauth.user.token', '')

    if (tokenCurren === '' && tokenPrev !== tokenCurren) {
      this.setState({ flagAuth: false })
    } else if (tokenCurren !== '' && !this.state.flagAuth) {
      this.setState({ flagAuth: true })
    }

    // Check if the path has changed to '/register'
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (this.props.location.pathname === '/register') {
        this.setState({ flagRegister: true })
      } else {
        this.setState({ flagRegister: false })
      }
    }
  }

  keyClickFunction(e) {

    if (isElectron()) {
      if (
        (e.ctrlKey && e.keyCode === 82) ||
        (e.ctrlKey && e.keyCode === 75) ||
        (e.ctrlKey && e.shiftKey && e.keyCode === 82) ||
        (e.ctrlKey && e.shiftKey && e.keyCode === 75) ||

        (e.metaKey && e.keyCode === 82) ||
        (e.metaKey && e.keyCode === 75) ||
        (e.metaKey && e.shiftKey && e.keyCode === 82) ||
        (e.metaKey && e.shiftKey && e.keyCode === 75) ||
        (e.metaKey && e.shiftKey && e.keyCode === 52) ||
        e.keyCode === 112 || // f1
        e.keyCode === 113 || // f2
        e.keyCode === 114 || // f3
        e.keyCode === 115 || // f4
        e.keyCode === 116 || // f5
        e.keyCode === 117 || // f6
        e.keyCode === 118 || // f7
        e.keyCode === 119 || // f8 
        e.keyCode === 120 || // f9
        e.keyCode === 121 || // f10
        e.keyCode === 122 || // f11
        e.keyCode === 123    // f12
      ) {
        e.preventDefault();
        return false;
      } else {
        return true;
      }
    }


  }

  handleRegister = () => {
    this.setState({ flagRegister: true })
    this.props.history.push('/register')
  }
  handleLogin = () => {
    this.setState({ flagRegister: true, flagAuth: false })
    this.props.history.push('/login')
  }

  render() {
    return (
      <div>
        {!this.state.flagAuth && !this.state.flagRegister && <LoginComp onRegister={this.handleRegister} onLogin={this.handleLogin} />}
        {!this.state.flagAuth && this.state.flagRegister && <RegisterComp onLogin={this.handleLogin} />}
        {this.state.flagAuth && <div className='container-main-box'>
          <ErrorBoundary>
            <Main />
          </ErrorBoundary>
        </div>}
      </div>
    )
  }
}

// AppContainer.js
const mapStateToProps = (state, ownProps) => ({
  netaauth: state.netaauth,
  register: state.register
})

const mapDispatchToProps = {
  setComp, savePage
}

const AppContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App))

export default AppContainer
